var map = {
	"./": [
		8610,
		9
	],
	"./Providers": [
		6427,
		9
	],
	"./Providers.d": [
		2446,
		9,
		446
	],
	"./Providers.d.ts": [
		2446,
		9,
		446
	],
	"./Providers.js": [
		6427,
		9
	],
	"./breakpoints": [
		3837,
		9
	],
	"./breakpoints.d": [
		7830,
		9,
		830
	],
	"./breakpoints.d.ts": [
		7830,
		9,
		830
	],
	"./breakpoints.js": [
		3837,
		9
	],
	"./colors": [
		5884,
		9
	],
	"./colors.d": [
		2233,
		9,
		233
	],
	"./colors.d.ts": [
		2233,
		9,
		233
	],
	"./colors.js": [
		5884,
		9
	],
	"./index": [
		8610,
		9
	],
	"./index.d": [
		4452,
		9,
		452
	],
	"./index.d.ts": [
		4452,
		9,
		452
	],
	"./index.js": [
		8610,
		9
	],
	"./ion-colors": [
		7914,
		9
	],
	"./ion-colors.d": [
		6767,
		9,
		767
	],
	"./ion-colors.d.ts": [
		6767,
		9,
		767
	],
	"./ion-colors.js": [
		7914,
		9
	],
	"./ion-fonts": [
		2096,
		9,
		96
	],
	"./ion-fonts.d": [
		8357,
		9,
		357
	],
	"./ion-fonts.d.ts": [
		8357,
		9,
		357
	],
	"./ion-fonts.js": [
		2096,
		9,
		96
	],
	"./ion-global-styles": [
		9252,
		9,
		252
	],
	"./ion-global-styles.d": [
		4254,
		9,
		254
	],
	"./ion-global-styles.d.ts": [
		4254,
		9,
		254
	],
	"./ion-global-styles.js": [
		9252,
		9,
		252
	],
	"./shadows": [
		5347,
		9
	],
	"./shadows.d": [
		2389,
		7,
		389
	],
	"./shadows.d.ts": [
		2389,
		7,
		389
	],
	"./shadows.js": [
		5347,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7760;
module.exports = webpackAsyncContext;